import type { CreateCompanyInput } from '@idc-forms/schemas'
import { useSidePanelStore } from '@/shared/store/side-panel.store'
import { useCreateCompanyMutation } from '../hooks/use-company-mutations'
import { CompanyForm } from './company-form'

type CompanyCreatePanelProps = {
  onDone?: () => void
}

/** "Nueva empresa" dentro del side panel: el mismo CompanyForm que la edición. */
export function CompanyCreatePanel({ onDone }: CompanyCreatePanelProps) {
  const closePanel = useSidePanelStore((s) => s.closePanel)
  const createMutation = useCreateCompanyMutation()
  const done = onDone ?? closePanel

  const handleSubmit = (values: CreateCompanyInput) => {
    createMutation.mutate(values, {
      onSuccess: () => {
        done()
      }
    })
  }

  return (
    <CompanyForm
      submitLabel="Crear empresa"
      pending={createMutation.isPending}
      onSubmit={handleSubmit}
      onCancel={done}
    />
  )
}
